import { render, staticRenderFns } from "./OverviewFile.vue?vue&type=template&id=4fe5b6f2"
import script from "./OverviewFile.vue?vue&type=script&lang=js"
export * from "./OverviewFile.vue?vue&type=script&lang=js"
import style0 from "./OverviewFile.vue?vue&type=style&index=0&id=4fe5b6f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports